import { routeInfo } from './../../../routeInfo';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import * as actions from '../../../redux/user/actions.user';
import UserInfoPopup from './UserInfoPopup';
import BalancePlate from '../BalancePlate/BalancePlate';
import tooltipService from '../../../services/tooltipService';
import HeaderPartSeparator from '../HeaderPartSeparator/HeaderPartSeparator';
import billingStatusHelper from '../../../services/mini/billingStatusHelper';
import BillingControlWrapper from '../../components/BillingControlWrapper/BillingControlWrapper';

class UserInfo extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            openedState: false
        };
    }

    componentDidMount() {
        this.props.getUserBalance();
    }

    componentDidUpdate(prevProps) {
        const curProps = this.props;
        const isProjectsView = window.location.pathname === routeInfo.projects.path;
        const isBillingView = window.location.pathname.indexOf("billing") > 0;
        if (!isProjectsView && !isBillingView) {
            if (curProps.hasProfileData && !prevProps.hasProfileData) {
                this.setState({
                    openedState: tooltipService.shouldShowDocsTooltip()
                });
            }
        }
    }

    toggleOpenState = () => {
        this.setState({ openedState: !this.state.openedState });
    }

    onOutsideClick = (e) => {
        const el = e.target;
        if (_.isFunction(el?.className?.indexOf) && el.className.indexOf('oc_avatar') === -1) {
            this.setState({ openedState: false });
        }
    }

    render() {
        const {
            hideBalanceBlock,
            billingStatus,
            memberOf,
        } = this.props;

        const { openedState } = this.state;

        const wrapperClasses = 'user-info';

        const { caseName, message } = billingStatusHelper(billingStatus, memberOf);

        return <div className={wrapperClasses}>
            {hideBalanceBlock !== true &&
                <BillingControlWrapper>
                    <Link to={routeInfo.billing.path} className="user-info_balance tablet-and-bigger">
                        <BalancePlate />
                    </Link>
                </BillingControlWrapper>}

            <HeaderPartSeparator
                height={32}
                marginLeft={16}
                marginRight={0} />

            <span className="user-info_avatar oc_avatar"
                onClick={this.toggleOpenState}>
                <i className={`icon ${!openedState ? 'icon-alan-header-menu' : 'icon-alan-header-menu-close'} oc_avatar`} />
                {!openedState &&
                    <div className="user-info_status-holder">
                        {caseName && <i className={`icon icon-alan-info-sign ${caseName}`} title={message} />}
                    </div>}
            </span>

            {openedState &&
                <UserInfoPopup
                    openedState={openedState}
                    onOutsideClick={this.onOutsideClick}
                />}
        </div>;
    }
}

function mapStateToProps({ user }) {
    return {
        hasProfileData: user.hasProfileData,
        balance: user.balance,
        billingStatus: user.billingStatus,
        freeInteractions: user.freeInteractions,
        hasPaymentInfo: user.hasPaymentInfo,
        memberOf: user.memberOf,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserBalance: () => dispatch(actions.getUserBalance()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);